import { jsx as l } from "react/jsx-runtime";
import { useChatbotContext as n } from "../../hooks/useChatbotContext.js";
function c({ children: p }) {
  const { cn: s, isPopup: o, embedConfig: t } = n(), e = (t == null ? void 0 : t.logoImageUrl) != null;
  return /* @__PURE__ */ l(
    "ul",
    {
      className: s(
        "flex grow flex-col items-stretch gap-y-5 px-4 pb-6 @notMobile:px-5 @notMobile:pb-10",
        {
          "pt-5": o && e,
          "pt-0": o && !e,
          "pt-6 @notMobile:pt-10": !o
        }
      ),
      children: p
    }
  );
}
export {
  c as Messages
};
